import { motion } from "framer-motion";

const STORY_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_web-forge-2354/artifacts/d76b138981b61691_IMG_0182.jpeg";

export default function StorySection({ content }) {
  return (
    <section id="story" className="relative z-10 bg-[#0c0c0f] py-20 sm:py-28 lg:py-36 border-t border-zinc-900" data-testid="story-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-md border border-zinc-800">
              <img src={STORY_IMG} alt="Mr Zee in the studio" className="w-full h-[420px] sm:h-[560px] object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0f] to-transparent opacity-60" />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-rose-600 px-6 py-4 rounded-sm shadow-[0_0_40px_rgba(225,29,72,0.4)]">
              <span className="font-anton text-3xl text-white leading-none">Z.N.</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-rose-500" data-testid="story-tag">
              {content.story_tag}
            </span>
            <h2 className="mt-5 font-anton uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9] text-white" data-testid="story-headline">
              {content.story_headline}
            </h2>
            <p className="mt-8 text-zinc-400 text-base sm:text-lg leading-relaxed" data-testid="story-body">
              {content.story_body}
            </p>

            <div className="mt-12 grid grid-cols-3 gap-4 sm:gap-6">
              {content.stats.map((s, i) => (
                <div key={i} className="border-l-2 border-rose-600 pl-4" data-testid={`stat-${i}`}>
                  <div className="font-anton text-3xl sm:text-4xl text-white leading-none">{s.value}</div>
                  <div className="mt-2 font-mono text-[10px] sm:text-xs uppercase tracking-wider text-zinc-300">{s.label}</div>
                  <div className="font-mono text-[10px] uppercase tracking-wider text-zinc-600">{s.sub}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
